/* eslint-disable no-debugger */
import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';

const initialState = {
  isLoading: false,
  error: '',
  categoryMsg: '',
  status: true,
  createCategoryStatus: false,
  fileCategoryList: [],
  disbaleFileCategoryList: [],
  categoryListByProject: [],
  checkCategoryLinked: ''
};

const slice = createSlice({
  name: 'filecategory',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // RESET ERROR
    resetCategoryError(state) {
      state.error = '';
    },
    // RESET MSG
    resetCategoryMsg(state) {
      state.categoryMsg = '';
    },
    // RESET CREATE STATUS
    resetCreateFileCategoryStatus(state) {
      state.createCategoryStatus = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createCategoryStatus = false;
      state.isLoading = false;
      state.error = message;
    },
    // STATUS
    fileCategoryStatus(state, action) {
      state.isLoading = false;
      state.status = action.payload;
    },
    // GET FILE CATEGORY LIST
    getFileCategoryListSuccess(state, action) {
      state.fileCategoryList = action.payload;
      state.isLoading = false;
    },
    // GET DISABLE FILE CATEGORY LIST
    getDisableFileCategorySuccess(state, action) {
      state.disbaleFileCategoryList = action.payload;
      state.isLoading = false;
    },
    getCategoryListByProjectSuccess(state, action) {
      const { data } = action.payload;
      if (data?.length === 0) {
        state.checkCategoryLinked = 'No Category is linked with selected client and project';
        state.categoryListByProject = data;
      } else {
        state.categoryListByProject = data;
        state.checkCategoryLinked = '';
      }
      state.isLoading = false;
    },
    resetCategoryListByProject(state) {
      state.categoryListByProject = [];
      state.isLoading = false;
      state.checkCategoryLinked = '';
    },
    // CREATE FILE CATEGORY
    createFileCategorySuccess(state, action) {
      const newCategory = action.payload;
      state.createCategoryStatus = true;
      state.isLoading = false;
      state.fileCategoryList = [...state.fileCategoryList, newCategory];
    },
    // UPDATE FILE CATEGORY
    updateFileCategorySuccess(state, action) {
      const category = action.payload;
      state.createCategoryStatus = true;
      const updateCategory = map(state.fileCategoryList, (_category) => {
        if (_category.id === category.id) {
          return category;
        }
        return _category;
      });
      state.isLoading = false;
      state.fileCategoryList = updateCategory;
    },
    // FILTER FILE CATEGORY
    filterFileCategorySuccess(state, action) {
      const category = action.payload;
      state.isLoading = false;
      if (state.status) {
        state.fileCategoryList = category;
      } else {
        state.disbaleFileCategoryList = category;
      }
    },
    // DISABLE OR RESTORE FILE CATEGORY
    statusChangeSuccess(state, action) {
      if (action.payload.message) {
        state.categoryMsg = action.payload.message;
      } else {
        const { id } = action.payload;
        const categoryStatus = filter(
          state.status ? state.disbaleFileCategoryList : state.fileCategoryList,
          (category) => category.id !== id
        );
        state.isLoading = false;
        if (state.status) {
          state.createCategoryStatus = false;
          state.categoryMsg = '';
          state.disbaleFileCategoryList = categoryStatus;
        } else {
          state.createCategoryStatus = true;
          state.fileCategoryList = categoryStatus;
        }
      }
    },
    // DELETE CLIENT
    deleteFileCategorySuccess(state, action) {
      const { id } = action.payload;
      const deleteEvent = filter(state.disbaleFileCategoryList, (category) => category.id !== id);
      state.isLoading = false;
      state.disbaleFileCategoryList = deleteEvent;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetCreateFileCategoryStatus, resetCategoryError, resetCategoryMsg, resetCategoryListByProject } =
  slice.actions;

// ----------------------------------------------------------------------

// GET FILE CATEGORY LIST GET
export function getFileCategoryList(status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/category-name/filter/item/?status=${status}`
      });
      if (status) {
        dispatch(slice.actions.getFileCategoryListSuccess(response.data));
      } else {
        dispatch(slice.actions.getDisableFileCategorySuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

//  get category list by project id selected
export function getCategoryListByProject(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/category/project/client/details?project_id=${id}`
      });
      dispatch(slice.actions.getCategoryListByProjectSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// CREATE CATEGORY POST
export function createCategory(categoryData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: 'http://smartcollect-api.cp360apps.com/file-management-system/category-name/create/',
        data: categoryData
      });
      dispatch(slice.actions.createFileCategorySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// EDIT OR UPDATE CATEGORY PUT
export function updateCategory(categoryData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/category-name/update/${id}/`,
        data: categoryData
      });
      dispatch(slice.actions.updateFileCategorySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// SEARCH AND FILTER CATEGORY GET
export function filterCategory(pageStatus, name) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.fileCategoryStatus(pageStatus));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/category-name/filter/item/?category_name=${name}&status=${pageStatus}`
      });
      dispatch(slice.actions.filterFileCategorySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DISABLING OR RESTORING OF PARTICULAR CATEGORY PUT
export function statusChange(id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.fileCategoryStatus(status));
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'put',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/category-name/update-status-${status}/${id}/`
      });
      dispatch(slice.actions.statusChangeSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// DELETE CATEGORY DELETE
export function deleteFileCategory(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'delete',
        url: `http://smartcollect-api.cp360apps.com/file-management-system/category-name/delete/${id}/`
      });
      dispatch(slice.actions.deleteFileCategorySuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}
